module.exports = __webpack_public_path__ + "static/img/a130.1ee07ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a130.jpg
// module id = wv8k
// module chunks = 0